import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSplitMulti = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.28 6.72a.75.75 0 0 1 0 1.061l-6.5 6.5a.75.75 0 1 1-1.06-1.06l6.5-6.5a.75.75 0 0 1 1.06 0Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.25 7.251a.75.75 0 0 1 .75-.75h2.75a.75.75 0 0 1 .75.75V10a.75.75 0 0 1-1.5 0V8.001h-2a.75.75 0 0 1-.75-.75M2.72 6.72a.75.75 0 0 0 0 1.061l6.5 6.5a.75.75 0 1 0 1.06-1.06l-6.5-6.5a.75.75 0 0 0-1.06 0Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M6.5 7.251a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75V10A.75.75 0 0 0 4 10V8.001h1.75a.75.75 0 0 0 .75-.75m3.657-4.441a.75.75 0 0 0-.75.75v11.193a.75.75 0 0 0 1.5 0V3.56a.75.75 0 0 0-.75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.477 5.071a.75.75 0 0 0 0-1.06L10.604 2.1a.75.75 0 0 0-1.06 0L7.856 4.01a.75.75 0 0 0 1.06 1.06l1.157-1.379 1.344 1.38a.75.75 0 0 0 1.06 0m-2.32 2.383a.75.75 0 0 0-.75.75v9.192a.75.75 0 0 0 1.5 0V8.204a.75.75 0 0 0-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSplitMulti;
